export enum PaymentTypes {
  BANESCO = 'BANESCO',
  OTHER_BANKS = 'OTHER_BANKS',
  INTERNATIONAL_REGIONAL = 'INTERNATIONAL_REGIONAL',
  STOCK_EXCHANGE = 'STOCK_EXCHANGE',
  SERVICES = 'SERVICES',
  TAXES = 'TAXES',
}
